import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if error is from tinyadz
    const errorString = error?.toString() || '';
    const errorStack = error?.stack || '';
    
    if (errorString.includes('tinyadz') || errorStack.includes('tinyadz')) {
      // Suppress tinyadz errors
      console.warn('TinyAdz error caught by ErrorBoundary and suppressed:', error);
      return { hasError: false }; // Don't show error UI
    }
    
    // For other errors, show error UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Check if error is from tinyadz
    const errorString = error?.toString() || '';
    const errorStack = error?.stack || '';
    const errorInfoString = JSON.stringify(errorInfo) || '';
    
    if (errorString.includes('tinyadz') || 
        errorStack.includes('tinyadz') || 
        errorInfoString.includes('tinyadz')) {
      console.warn('TinyAdz error caught by ErrorBoundary and suppressed:', error);
      return; // Don't log or handle tinyadz errors
    }
    
    // Log other errors
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Only show error UI for non-tinyadz errors
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

